import React, { useState, useEffect } from "react"
import { useNavigate, useSearchParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { FreemiumSignupPage } from "./components"

/**
 * Page component for creating a freemium account.
 * Handles the multi-step signup process, including:
 *  - Initial signup for a freemium trial account
 *  - Handling of user authentication and token-based signup completion
 * 
 * The flow is as follows:
 *  1. Displays the CreateFreemiumAccountPage component for the user to enter details.
 *  2. After successful signup, navigates to an email verification step.
 *  3. If the user is already authenticated and not in the "Trialing" onboarding stage, they are redirected to the home page.
 *  4. Supports both fresh signup (without token) and token-based signup completion.
 */

const CreateFreemiumAccountPage = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const token = searchParams.get("token")
  const [step, setStep] = useState(0)
  const auth = useSelector((state) => state.auth)
  
  const mode = token ? "complete-signup" : "signup"
  
  useEffect(() => {
    if (auth.isAuthenticated && auth.onboardingStage !== "Trialing") {
      navigate("/")
      return
    }
    
    if (mode === "complete-signup") {
      navigate("/freemium-complete-signup")
    }
  }, [auth, navigate, mode])
  
  const handleNextStep = () => {
    setStep(1)
    navigate("/freemium-verification-email")
  }
  
  if (mode === "signup" && step === 0) {
    return <FreemiumSignupPage nextStep={handleNextStep} />
  }
 
  return null
}

export default CreateFreemiumAccountPage